/**
 * リリースノート（DF Scanner）
 * @returns JSX.Element
 */
export const ReleaseNotesDfScanner = () => {
    return (
        <div>
            {/* Pro版 v1.9.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.9.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-08-28</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.9.2がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>バグ修正</p>
                    <p>・ベクター結合機能で、重複していないポリゴンの形状が意図せず変更される問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.9.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.9.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-07-31</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.9.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>バグ修正</p>
                    <p>
                        ・解析範囲ファイルの指定が一部の操作で無視されて全域が処理される問題を修正（樹頂点検出 /
                        針葉樹用樹冠分離 / AI樹冠分離 / マルチレイヤーセグメンテーション）
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.9.0, Lite版 v1.9.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.9.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.9.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-07-21</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.9.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.9.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>新機能</p>
                    <p>・スクリーンショット機能の追加</p>
                    <p>・ポリゴンレイヤの枠線太さをプロパティで設定できる機能の追加</p>
                    <br />
                    <p>機能改善</p>
                    <p>・エリア統計情報計算において、出力可能な統計データを追加</p>
                    <p>・ポリゴン編集において、矩形ポリゴンを作成できる機能を追加</p>
                    <p>・国土地理院DEMを以前より新しいデータが使用できるよう改善</p>
                    <p>
                        ・エリア統計・選択エリアの統計における面積を、球体近似から楕円体モデルでの測地線面積による算出に修正
                    </p>
                    <p>・ポイントデータの描画高速化</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・プロジェクト保存機能で背景地図やラスタ表示設定が保存されなかった問題を修正</p>
                    <p>・その他軽微なバグを修正</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>機能改善</p>
                    <p>・マスク未指定時のマルチレイヤーセグメンテーションの挙動を修正</p>
                    <p>・AI樹冠分離の後処理方法を修正</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・バンド結合機能で出力されるデータが表示上ずれることのある問題を修正</p>
                    <p>・倒木リスク判定機能において、＋αの値を設定した場合に誤った樹高値が出力されていた問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.8.1, Lite版 v1.8.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.8.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.8.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-22</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.8.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.8.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・フライト用DEM取得機能で、ジオイド高の計算処理に誤りがあった問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.8.0, Lite版 v1.8.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.8.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.8.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-14</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.8.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.8.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>新機能</p>
                    <p>・フライト用DEMデータ取得機能の追加</p>
                    <p>・ラスターデータの表示設定機能の追加</p>
                    <p>・マルチバンドデータの描画対応</p>
                    <br />
                    <p>UI改善</p>
                    <p>・メニュー構成の整理</p>
                    <p>・ラインデータの表示調整</p>
                    <br />
                    <p>機能改善</p>
                    <p>・北海道モデルの更新</p>
                    <p>・Windowsセキュリティ機能への対応を改善</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>新機能</p>
                    <p>・多様性評価機能の追加</p>
                    <p>・エリアを指定した樹頂点検出・樹冠分離機能の追加</p>
                    <p>・ベクターデータ結合機能の追加</p>
                    <p>・ラスターデータのバンド結合機能の追加</p>
                    <br />
                    <p>機能改善</p>
                    <p>・My樹種識別AIのデフォルトepoch数の見直し</p>
                    <p>・My樹種識別AIの学習履歴グラフ出力への対応</p>
                    <p>・My樹種識別AIのマルチバンド画像への対応</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・GPU搭載PCで作成したモデルが、GPUのないPCで使用できない問題への対応</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.7.1, Lite版 v1.7.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.7.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.7.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-03-06</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.7.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.7.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能改善</p>
                    <p>・マスキング機能、樹頂点検出アルゴリズムの調整</p>
                    <p>・樹冠間に隙間があるデータに対する林相図作成アルゴリズムの改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>
                        ・樹頂点検出で、異なるCHMから作成したマスク画像使用時に正しくマスクされないことがある問題を修正
                    </p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>バグ修正</p>
                    <p>・テーブル計算で条件に小数値を指定できなかった問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.7.0, Lite版 v1.7.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.7.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.7.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-01-29</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.7.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.7.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>新機能</p>
                    <p>・ラインデータ編集機能の追加</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・その他軽微なバグの修正</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>新機能</p>
                    <p>・道路等からの距離による倒木リスク判定機能の追加</p>
                    <p>・全自動枯死木検出機能の追加</p>
                    <br />
                    <p>機能改善</p>
                    <p>・日本の樹種識別モデルの更新</p>
                    <p>・地域に応じた樹種自動選択機能の追加（日本の樹種識別）</p>
                    <p>・AI樹冠分離におけるマスクデータ指定機能の追加</p>
                    <p>・教師なし分類で使用するモデルの更新</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.4, Lite版 v1.6.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.6.4</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.6.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-24</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.6.4がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.6.4がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・DBH推定において、樹種が誤って「その他広葉樹」として扱われ、推定精度が低下していた問題を修正</p>
                    <p>
                        ・極端に横長・縦長のデータにおいて、樹頂点検出の詳細設定の値が適切に反映されていなかった問題を修正
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.3, Lite版 v1.6.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.6.3</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.6.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.6.3がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.6.3がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・Windows Updateに伴いログインに失敗する問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.2, Lite版 v1.6.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.6.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.6.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-11-26</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.6.2がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.6.2がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能改善</p>
                    <p>・ベースマップ表示のプロキシ対応および最適化</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・Site Tuningで、2回目以降の処理が高速化されない問題を修正</p>
                    <p>・プロジェクト保存時に、異なるドライブ上のファイルが含まれる場合に発生していたエラーを改善</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>機能改善</p>
                    <p>・AI樹冠分離を高解像度データにも対応</p>
                    <p>・AI樹冠分離で、小さな穴が発生しないよう処理を改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・AI樹冠分離の後処理でエラーが発生する場合がある問題を修正</p>
                    <p>・テーブル計算機能で、条件式と出力列が同一の場合に計算されない問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.1, Lite版 v1.6.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.6.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.6.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-10-30</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.6.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.6.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能改善</p>
                    <p>・起動速度の高速化</p>
                    <p>・インストーラーの挙動を改善</p>
                    <p>・全自動処理の樹種識別で、その他広葉樹への識別されやすさを調整</p>
                    <p>・高解像度データの樹種識別精度を改善</p>
                    <p>・CHM計算処理の最適化</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・複数GeoTIFFの同時インポート時にパンされない問題を修正</p>
                    <p>・一部のGeoTIFFファイルが黒く表示されてしまう問題を修正</p>
                    <p>・英語版でGeoTIFFインポートに失敗することのある問題の修正</p>
                    <p>・ポイント編集の際に、マルチポイントとポイントが混在している場合に保存されない問題を修正</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>機能改善</p>
                    <p>・AI樹冠分離（β版）の精度を改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・オフライン環境等でMyモデル作成の精度が低くなることのある問題を修正</p>
                    <p>・Myモデル識別で失敗することのある問題を修正</p>
                    <p>・Onetimeディープラーニングが失敗する問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.6.0, Lite版 v1.6.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.6.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.6.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-09-30</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.6.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.6.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>新機能</p>
                    <p>・DF Walkerで記録した現地DBHデータを樹冠データに割り当てる機能</p>
                    <p>・ユーザー設定により、樹種表示色を固定する機能</p>
                    <p>・GPU環境診断機能</p>
                    <br />
                    <p>機能改善</p>
                    <p>・GeoTIFFファイルを読み込む際の挙動修正・描画高速化</p>
                    <p>・樹冠分離の際に、オルソ画像がなくても動作するように改善</p>
                    <p>・スギ・ヒノキ識別、北海道針葉樹識別におけるその他樹種の識別精度改善</p>
                    <p>・樹種識別での処理の最適化</p>
                    <p>・領域クリッピング機能で、複数ポリゴンのクリップ領域に対応</p>
                    <p>・高緯度地域でも画像などが歪まないように改善</p>
                    <p>・ライン/マルチライン/マルチポイントの描画に対応</p>
                    <p>・DBH推定にエゾマツ/アカエゾマツモデルを追加</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・樹頂点がCHM範囲外にもあった場合、樹高推定時にエラーが発生する問題の修正</p>
                    <p>・CHM計算時に、失敗することのある問題の修正</p>
                    <p>・起動時に一瞬黒い画面が表示されて画面が固まる問題の修正</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>新機能</p>
                    <p>・AI樹冠分離機能 - β版（広葉樹樹冠分離）</p>
                    <br />
                    <p>機能改善</p>
                    <p>・教師なし分類の識別結果をSP-1, SP-2, ...のような名前に変更</p>
                    <p>・My樹種識別AIで、閾値設定機能を追加</p>
                    <p>・枯死木検出時に、枯死木のみをデフォルトで出力するように改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・Myデータ作成で、保存先の階層が深い場合にエラーが発生する問題の修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.5.2, Lite版 v1.5.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.5.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.5.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-07-16</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.5.2がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.5.2がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・北海道・青森・岩手・宮城のデータにおいて、全自動処理時にエラーが発生していた問題を修正</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>バグ修正</p>
                    <p>・枯死木検出機能で、精度が一時的に低下していた問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.5.1, Lite版 v1.5.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.5.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.5.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-07-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.5.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.5.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能改善</p>
                    <p>・テーブルから地物にパン・ズームする機能の挙動改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・ポリゴン編集時にdelキーでエラーが発生する問題を修正</p>
                    <p>・ポリゴン編集時に戻る操作が効かなくなる問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.5.0, Lite版 v1.5.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.5.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.5.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-07-03</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.5.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.5.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>新機能</p>
                    <p>・テーブルから地物にパン・ズームする機能</p>
                    <p>・距離・面積計算機能</p>
                    <p>
                        ・DF
                        Walkerで作成した現地樹種データを別の樹冠ポリゴンに自動で割り当てる機能（現地樹種割り当て機能）
                    </p>
                    <br />
                    <p>機能改善</p>
                    <p>・ベースマップをアイコンから選択できるように改善</p>
                    <p>・スギ・ヒノキ識別のモデルを更新</p>
                    <p>・オフラインアクティベーション機能の改善</p>
                    <p>・幹材積推定/CO2固定量計算でデフォルトで選択される樹種を改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・NVIDIA GeForce RTX50シリーズ対応</p>
                    <p>・その他軽微なバグの修正</p>
                    <br />
                    <p className="font-bold">■ Pro版</p>
                    <p>機能改善</p>
                    <p>・テーブル計算機能で、文字列入力とlog計算に対応</p>
                    <p>・北海道針葉樹識別のモデルを更新</p>
                    <br />
                    <p className="font-bold">■ Lite版</p>
                    <p>新機能</p>
                    <p>・針葉樹樹冠分離機能をPro版同様に実装</p>
                    <p>・スギヒノキ識別機能をPro版同様に実装</p>
                    <p>・北海道針葉樹識別機能をPro版同様に実装</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.4.1, Lite版 v1.4.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.4.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.4.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-05-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.4.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.4.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・幹材積推定時の軽微なバグを修正</p>
                    <p>・CO2固定量計算時の軽微なバグを修正</p>
                    <p>・ソフトウェアが適切に終了せずアップデートに失敗する問題を解消</p>
                    <p>・zip形式の国土地理院DEMインポート時のバグ修正、および、DEM1Aデータ対応</p>
                    <br />
                    <p>機能改善</p>
                    <p>・ポリゴン編集終了時のデフォルト最小面積を変更</p>
                    <p>・樹冠→樹頂点変換の入力ファイル形式を変更（.crown.shp→.shp）</p>
                    <p>・一部英語表記修正</p>
                    <br />
                    <p className="font-bold">■ Pro版のみ</p>
                    <p>バグ修正</p>
                    <p>・Myデータ作成時の軽微なバグを修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.4.0, Lite版 v1.4.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.4.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.4.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-04-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.4.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.4.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能追加</p>
                    <p>・樹冠→樹頂点変換機能</p>
                    <p>・樹頂点編集機能</p>
                    <br />
                    <p>機能改善</p>
                    <p>・CHM計算で、DTMデータとしてNASADEMデータが使用できるようになりました。</p>
                    <p>・ポリゴン編集終了時、不適切なポリゴンを削除する機能等が追加されました。</p>
                    <p>・林班統計情報計算の出力形式を整形しました。</p>
                    <p>・データ描画を高速化しました。</p>
                    <p>・DBH計算時に北海道樹種が反映されるようになりました。</p>
                    <br />
                    <p className="font-bold">■ Pro版のみ</p>
                    <p>機能追加</p>
                    <p>・テーブル演算機能</p>
                    <p>・枯死木検出機能</p>
                    <p>・北海道樹種識別機能 (β版)</p>
                    <br />
                    <p className="font-bold">■ Lite版のみ</p>
                    <p>その他</p>
                    <p>・恒久版ライセンスに対応しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.2, Lite版 v1.3.2, v1.8.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.3.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.3.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.8.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-01-21</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.3.2がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.3.2がリリースされました。</p>
                    <p>DF Scanner v1.8.2がリリースされました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・林班統計情報計算で結果が正しく出力されない問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.1, Lite版 v1.3.1, v1.8.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.3.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.3.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.8.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-12-23</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.3.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.3.1がリリースされました。</p>
                    <p>DF Scanner v1.8.1がリリースされました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・ポリゴン編集時のショートカットキーを押したときに稀に発生する不具合を修正</p>
                    <p>・DBH推定式追加後、適切に削除ができない問題を修正</p>
                    <p>・一部シェープファイルの表示ができない問題の修正</p>
                    <p>・お問い合わせダイアログの表示が崩れることのある問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.0, Lite版 v1.3.0, v1.8.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.3.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.3.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.8.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-11-21</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.3.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.3.0がリリースされました。</p>
                    <p>DF Scanner v1.8.0がリリースされました。</p>
                    <br />
                    <p>機能追加</p>
                    <p>・教師なし分類機能を追加（Pro版）</p>
                    <p>・選択統計情報計算と林班統計情報計算機能で、相対幹距比を計算する機能を追加</p>
                    <br />
                    <p>機能改善</p>
                    <p>・日本の樹種識別モデルを更新（Pro版）</p>
                    <p>・幹材積推定で適切にデフォルト地域が選ばれるように改善</p>
                    <p>・メニューの文言、UIを改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・特定のファイルを使用した際にCHMが適切に計算されない問題を修正</p>
                    <p>・Myモデル作成時にまれに樹種の入れ替わりが起こる問題を修正（Pro版）</p>
                    <p>・AI学習時に、列から学習データを再読み込みする際の挙動を修正（Pro版）</p>
                    <p>・特定のシェープファイルが読み込めない問題を修正</p>
                    <br />
                    <p>その他</p>
                    <p>・CHM補正のデフォルト補正方法を斜め→鉛直に変更</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.2.1, Lite版 v1.2.1, v1.7.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.2.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.2.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.7.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-09-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.2.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.2.1がリリースされました。</p>
                    <p>DF Scanner v1.7.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・オルソ画像がCHMより小さい場合に樹種識別できないエラーを修正しました。</p>
                    <p>・林班統計情報計算時にWGS84以外のデータを使用した場合のエラーを修正しました。</p>
                    <p>・オルソ画像インポート時にエラーが発生する場合がある点を修正しました。</p>
                    <p>・Bigtiff使用時のCHM計算の挙動を修正しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.2.0, Lite版 v1.2.0, v1.7.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.2.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.2.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.7.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-08-23</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.2.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.2.0がリリースされました。</p>
                    <p>DF Scanner v1.7.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能追加</p>
                    <p>・地面補正機能をリニューアルしました。</p>
                    <p>・スギヒノキ分類のモデル更新をしました。</p>
                    <p>・炭素蓄積量推定からCO2固定量推定に変更しました。</p>
                    <p>・林相図作成機能を追加しました。</p>
                    <p>・GeoJSONファイルの表示に対応しました。</p>
                    <p>・ドーナツ型ポリゴン、マルチポリゴンの表示に対応しました。</p>
                    <p>・複数ファイルインポートに対応しました。</p>
                    <p>・Informationボタンでポリゴン情報が確認できるようになりました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・ポリゴン描画のパフォーマンスを改善しました。</p>
                    <p>・ベースマップ表示を修正しました。</p>
                    <p>・overview付きのGeoTIFFファイルの読み込みを高速化しました。</p>
                    <p>・選択統計情報計算を高速化しました。</p>
                    <p>・樹頂点検出アルゴリズムを一部改善しました。</p>
                    <br />
                    <p>その他</p>
                    <p>・オンラインバックアップ使用時のDFアカウント認証が追加されました。</p>
                    <p>・GPU版とCPU版のインストーラを統一しました。</p>
                    <p>・画面の一部文言修正や解析パラメータの説明等を追加しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.1.1, Lite版 v1.1.1, v1.6.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.1.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.1.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.6.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-06-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.1.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.1.1がリリースされました。</p>
                    <p>DF Scanner v1.6.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・初回起動時にプロジェクト保存が使用できない問題を修正しました。</p>
                    <p>・ポリゴン編集時にgeometryが空のポリゴンができる問題を修正しました。</p>
                    <p>・ポリゴン編集時に新規に作成したファイルの左に列が追加できない問題を修正しました。</p>
                    <p>・tfwファイルがあるときにGeoTIFFファイルとして認識されない問題を修正しました。</p>
                    <br />
                    <p>その他</p>
                    <p>・ソフトウェアのデフォルトのインストール先を変更しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.1.0, Lite版 v1.1.0, v1.6.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.1.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.1.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.6.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-05-14</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.1.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.1.0がリリースされました。</p>
                    <p>DF Scanner v1.6.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能追加</p>
                    <p>・地面補正時のオプションを追加しました（鉛直補正）。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・DBH推定精度が向上しました。</p>
                    <p>・林班統計情報計算で非植生を計算対象外とするよう修正しました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・針葉樹樹冠分離時にポリゴンが抜ける問題を修正しました。</p>
                    <p>・ポリゴン編集時のバグを修正しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.2, Lite版 v1.0.2, v1.5.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.0.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.0.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.5.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-27</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.0.2がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.0.2がリリースされました。</p>
                    <p>DF Scanner v1.5.2がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能改善</p>
                    <p>・樹頂点検出、樹冠分離時の挙動を一部改善しました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・ポリゴン編集時のバグを修正しました。</p>
                    <p>
                        ・マルチレイヤーセグメンテーション時の最小樹冠サイズのパラメータがうまく機能していない問題を修正しました。
                    </p>
                    <p>・ログファイル出力の不具合を修正しました。</p>
                    <br />
                    <p className="font-bold">■ Lite版 v1.0.2向け</p>
                    <p>機能追加</p>
                    <p>・サイズ再計算のメニューを追加しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.1, Lite版 v1.0.1, v1.5.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.0.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.0.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.5.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-11</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.0.1がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.0.1がリリースされました。</p>
                    <p>DF Scanner v1.5.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・樹種識別時にエラーになる問題を解消しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.0, Lite版 v1.0.0, v1.5.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF Scanner Pro版 v1.0.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner Lite版 v1.0.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF Scanner v1.5.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-07</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner Pro版 v1.0.0がリリースされました。</p>
                    <p>DF Scanner Lite版 v1.0.0がリリースされました。</p>
                    <p>DF Scanner v1.5.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>新機能</p>
                    <p>・全自動解析機能を追加しました。</p>
                    <p>・領域クリッピング機能を追加しました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・スギ・ヒノキ識別モデルを改良しました。</p>
                    <p>・ソフトウェア起動時に不要なキャッシュの削除をするよう修正しました。</p>
                    <br />
                    <p className="font-bold">■ Pro版 v1.0.0, DF Scanner v1.5.0向け</p>
                    <p>機能改善</p>
                    <p>・樹種情報がない場合でもDBH推定ができるよう修正しました。</p>
                    <p>・DBH推定時に樹冠面積を再計算するよう修正しました。</p>
                    <p>・ポリゴン作成機能を一部改善しました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・Myモデル作成時に列が参照されない問題を修正しました。</p>
                    <p>・Myモデル作成の画像切り抜き時にずれる問題を修正しました。</p>
                    <br />
                </div>
            </div>

            {/* v1.4.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.4.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-02-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.4.1がリリースされました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・ポリゴンラインの太さが、拡大縮小時に自動で変化するようになりました。</p>
                    <p>・ポイントサイズが、拡大縮小時に自動で変化するようになりました。</p>
                    <p>・ポリゴン編集の際のショートカットキー（追加・削除・結合・分割・削除）を追加しました。</p>
                    <p>・ポリゴン編集時に、ホイールを押し込みながら移動できるようになりました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・選択統計情報計算を行うとエラーが出る問題を修正しました。</p>
                    <p>
                        ・sitetuningやOnetime Deeplearningで、同じファイルで2回解析したときに列名が「樹種_x,
                        樹種_y」になる問題を修正しました。
                    </p>
                    <p>・テーブル編集時に「polygonID」列を付けなおすとエラーが出る問題を修正しました。</p>
                    <p>・小さいポリゴンが読み込まれた際に頂点数が減ってしまう問題を修正しました。</p>
                    <p>・新規シェープファイル作成時、表示/非表示を切り替えると表示されなくなる問題を修正しました。</p>
                </div>
            </div>

            {/* v1.4.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.4.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-01-24</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.4.0がリリースされました。</p>
                    <br />
                    <p>新機能</p>
                    <p>・ポリゴンデータの編集時に、テーブルの編集ができるようになりました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・林班統計情報計算ができない問題を修正しました。</p>
                    <p>・マスク画像生成時にオルソ画像とCHMデータのCRSが異なる際に計算が止まる問題を修正しました。</p>
                    <p>・樹頂点検出時に、CHMの平滑化の有効化チェックを外したときに動かない問題を修正しました。</p>
                    <p>
                        ・マルチレイヤーセグメンテーションで出力されるシェープファイルのエンコーディングをShift_JISに変更しました。
                    </p>
                    <p>・サイズの大きなファイルでCHM計算が止まることのある問題を修正しました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・針葉樹樹冠分離処理を高速化しました。</p>
                    <p>・樹種識別処理を高速化しました。</p>
                    <p>・大きなGeoTIFFファイルの描画処理を高速化しました。</p>
                </div>
            </div>

            {/* v1.3.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.3.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-13</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.3.3がリリースされました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・オフライン時7日間ログインできる機能の問題修正</p>
                </div>
            </div>

            {/* v1.3.2*/}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.3.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.3.2がリリースされました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・Onetime Deeplearningが動かない問題の修正</p>
                    <p>・製品版でプロジェクト保存機能が動かない問題の修正</p>
                    <p>・マスキングの際に、デフォルトで動かないデータに対する挙動の修正</p>
                </div>
            </div>

            {/* v1.3.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.3.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.3.1がリリースされました。</p>
                    <br />
                    <p>DF Scanner v1.3.1では、以下の追加機能が追加されています。</p>
                    <p>- ポリゴンの編集機能（追加・削除・分割・結合）</p>
                    <p>- 林班統計情報計算（樹冠ポリゴン・樹頂点に対応）</p>
                    <p>- LiDARデータから作成したCHMに対応したマスク画像作成機能</p>
                    <p>- 樹頂点の樹高計算機能</p>
                    <br />
                    <p>また、以下の項目を改善いたしました。</p>
                    <p>針葉樹樹冠分離機能の高速化</p>
                    <p>ポリゴンの樹高計算機能の高速化</p>
                    <br />
                    <p>加えて、マニュアルの更新等、ドキュメントを追加しました。</p>
                    <p>マニュアルの更新</p>
                    <p>目的別手順の説明を追加</p>
                    <p>PDFによる簡易マニュアル</p>
                    <p>解析方法を説明するYouTubeリンク</p>
                    <p>プライバシーポリシーの追記</p>
                    <br />
                    <p>その他軽微な問題を修正しました。</p>
                    <br />
                    <p>また、今回からWeb上でクレジット支払いにも対応するようになりました。</p>
                    <p>詳細は、弊社DF WebServiceページをご確認ください。</p>
                </div>
            </div>

            {/* v1.2.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.2.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-10-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>機能改善</p>
                    <p>・樹種識別モデルを更新しました。</p>
                    <p>・わかりにくかったUIを一部簡素化しました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・一部読み込めなかったデータに対応しました。</p>
                    <p>・その他軽微な問題を修正しました。</p>
                </div>
            </div>

            {/* v1.2.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.2.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-04-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>追加機能</p>
                    <p>・プロジェクト保存機能を実装しました。</p>
                    <p>・プロジェクトデータのオンラインバックアップ機能を実装しました。</p>
                    <p>・広葉樹の樹冠分離機能「マルチレイヤーセグメンテーション」を実装しました。</p>
                    <p>・CHM計算時に国土地理院のDEMデータをオンラインから利用する機能を実装しました。</p>
                    <p>・WGS84以外の座標参照系データの描画・解析に対応しました。</p>
                    <p>・樹種識別モデルのアップデートを行いました。</p>
                    <p>・樹種の教師無し分類を実装しました。</p>
                    <p>・現地データからのDBH推定式作成機能を実装しました。</p>
                    <p>・シェイプファイルの透過描画を可能にしました。</p>
                    <p>・全ツールの英語化を行いました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・一部オルソ画像の描画に失敗する問題を修正しました。</p>
                    <p>・針葉樹樹冠分離が一部データで動かない問題を修正しました。</p>
                    <p>・座標参照系変換機能が一部データに利用できない問題を修正しました。</p>
                    <p>その他</p>
                    <p>・利用規約を更新しました。</p>
                    <p>・マニュアルをアップデートしました。</p>
                    <p>・英語版マニュアルを公開しました。</p>
                    <p>・インストーラーの多言語対応を行いました。</p>
                </div>
            </div>

            {/* v1.1.6 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.6</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-11-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>バグ修正</p>
                    <p>・新たにDF Scannerをインストールした際に、起動しない問題を解決しました。</p>
                </div>
            </div>

            {/* v1.1.5 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.5</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-11-17</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>追加機能</p>
                    <p>・英語対応しました。</p>
                    <p>・広葉樹の樹種識別精度が向上しました。</p>
                    <p>・解析後に解析結果をインポートする機能を追加しました。</p>
                    <p>・針葉樹樹冠分離計算速度が向上しました。</p>
                    <p>・新たな樹冠分離プログラムを追加しました。</p>
                    <p>・TIFFファイルの描画が、2回目以降高速化しました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・アップデート時にプログラムが起動しなくなる問題を修正しました。</p>
                    <p>・大きいサイズのデータで解析ができない問題を修正しました。</p>
                    <p>・その他軽微な修正を行いました。</p>
                    <p>その他</p>
                    <p>・マニュアルをアップデートしました。</p>
                </div>
            </div>

            {/* v1.1.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-09-30</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>追加機能</p>
                    <p>・座標参照系変換機能が追加されました。</p>
                    <p>・ラスター値の取得機能が追加されました。</p>
                    <p>・解析後に解析結果をインポートする機能を追加しました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・幹材積計算プログラムの計算式のバグを修正しました。</p>
                    <p>・CHM計算時にDEMの値が一部抜けている場合に正しく計算が行われないバグを修正しました。</p>
                    <br />
                    <p>その他軽微な修正を行いました。</p>
                    <p>マニュアルをアップデートしました。</p>
                </div>
            </div>

            {/* v1.1.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-09-20</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>バグ修正</p>
                    <p>・幹材積計算プログラムの計算式のバグを修正しました。</p>
                </div>
            </div>

            {/* v1.1.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-08-26</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>バグ修正</p>
                    <p>・一部のPCで起動しない問題を修正しました。</p>
                </div>
            </div>

            {/* v1.1.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.1.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-08-26</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>追加機能</p>
                    <p>・炭素蓄積量推定機能が追加されました。</p>
                    <p>・ディアクティベーション機能が追加されました。</p>
                    <p>・統計情報に面積・密度・面積あたり幹材積量・炭素蓄積量が追加されました。</p>
                    <br />
                    <p>精度・機能改良</p>
                    <p>・スギ・ヒノキ識別モデルが改良されました。</p>
                    <p>・樹種識別時の画像抽出機能が高速化されました。</p>
                    <p>・幹材積推定機能が更新されました。</p>
                    <p>・幹材積推定機能が高速化されました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・スプラッシュスクリーンが解析時表示されるバグを修正しました。</p>
                </div>
            </div>

            {/* v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Scanner v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-07-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Scanner v1.0.0をリリースしました。</p>
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDfScanner;
